import React from "react";
import "./Quote.css";

const MarqueeMessage = ({ message }) => {
  return (
    <div className="marquee-wrapper">
      <div className="marquee">
        <span>{message}</span>
        <span>{message}</span> {/* duplicate for seamless scrolling */}
      </div>
    </div>
  );
};

export default MarqueeMessage;
